<div class="equis" (click)="onCancel()">X</div>
<h1 class="evento-title">Feria escolar</h1>
<div class="evento-line"></div>
<div class="evento-desc">
  Selecciona la opción de mundo virtual que más se ajuste a la experiencia que
  quieres ofrecer a tus clientes .
</div>

<div class="row cards">
  <div class="col-md-6 col-sm-12">
    <mat-card class="card-evento card">
      <div class="superior-line"></div>
      <mat-card-content>
        <p class="subtitle-evento">Feria escolar</p>
        <div class="inferior-line"></div>
        <p class="descripcion-evento">
          Activa tu exposición. Crea y personaliza pabellones, stands y
          vestíbulos para recibir a lo visitantes. Permite que los asistentes
          selecciones su avatar, interactúen con otros y adquieran los productos
          de cada stand.
        </p>
        <img
          src="../../../../assets/images/Imagen-escolar.JPG"
          alt=""
          class="img-evento"
        />
      </mat-card-content>
      <mat-card-actions>
        <button
          mat-button
          class="btn btn-evento"
          (click)="openEConferenciaModal()"
        >
          Construir
        </button>
      </mat-card-actions>
    </mat-card>
  </div>
</div>
